import script from "./PreLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PreLoader.vue?vue&type=script&setup=true&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=7ca771da&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca771da"]])

export default __exports__